import { render, staticRenderFns } from "./ChoiceMessage.vue?vue&type=template&id=0fc7f66c&scoped=true&"
import script from "./ChoiceMessage.vue?vue&type=script&lang=js&"
export * from "./ChoiceMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceMessage.vue?vue&type=style&index=0&id=0fc7f66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7f66c",
  null
  
)

export default component.exports